export default {
  banOperate: true,
  props: [
    {
      attr: 'videoname',
      name: '视频名称'
    },
    {
      attr: 'videourl',
      name: '视频链接'
    },
    {
      attr: 'videocode',
      name: '视频密码'
    }
  ]
}
